// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"302":"book-view","372":"home-view","725":"404-view","855":"books-view"}[chunkId] + "." + {"302":"bfc5a988","372":"770f1e38","725":"b779de90","855":"bd9949cb"}[chunkId] + ".chunk.js";
};